import { UITypes } from "types"

import RateCell from "components/table/columnComponents/RateCell"
import StatusCell from "components/table/columnComponents/StatusCell"

export const adHocReportHeaderCells: UITypes.TableHeaderCell[] = [
  { title: "Thermostat S/N", type: "sort-search", name: "sn", size: "middle" },
  { title: "Customer Email", type: "sort-search", name: "customer_email", size: "middle" },
  { title: "Status", type: "sort", name: "status", size: "small", cellComponent: StatusCell },
  {
    title: "Online %",
    type: "sort",
    name: "online_percentage",
    size: "middle",
    cellComponent: RateCell,
  },
  { title: "Address", type: "sort-search", name: "address", size: "middle" },
  { title: "Thermostat Name", type: "sort-search", name: "thermostat_name", size: "middle" },
]
